import React from 'react';

import {CheckOutStatus, CheckOutStatusInfo, SampleStatusItem} from 'constants/SampleStatusConstants';
import WarningIcon from 'ui-library/icons/WarningIcon';

interface Props {
  items: Array<SampleStatusItem>;
  shouldWarnIfCheckedOutForCurrentUser: boolean;
  shouldWarnIfReservedForCurrentUser: boolean;
}

function filterStatusInfosWithStatus(
  statusInfos: Array<CheckOutStatusInfo | undefined>,
  status: CheckOutStatus
): Array<CheckOutStatusInfo | undefined> {
  return statusInfos.filter((statusInfo) => statusInfo && statusInfo.status === status);
}

function getWarningMessage(props: Props): string | null {
  const itemStatuses = props.items.map((item) => item.checkOutStatusInfo);
  const reservedStatuses = filterStatusInfosWithStatus(itemStatuses, CheckOutStatus.RESERVED);
  const checkedOutStatuses = filterStatusInfosWithStatus(itemStatuses, CheckOutStatus.CHECKED_OUT);

  if (reservedStatuses.length + checkedOutStatuses.length === 0) {
    return null;
  } else if (checkedOutStatuses.length > 0) {
    if (checkedOutStatuses.some((statusInfo) => statusInfo && !statusInfo.isAssignedToCurrentUser)) {
      return 'Contains items checked-out by other users';
    } else if (props.shouldWarnIfCheckedOutForCurrentUser) {
      return 'Contains checked-out items';
    }
  } else if (reservedStatuses.some((statusInfo) => statusInfo && !statusInfo.isAssignedToCurrentUser)) {
    return 'Contains items reserved by other users';
  } else if (props.shouldWarnIfReservedForCurrentUser) {
    return 'Contains reserved items';
  }
  return null;
}

CICOValidationLabel.defaultProps = {
  shouldWarnIfCheckedOutForCurrentUser: false,
  shouldWarnIfReservedForCurrentUser: false,
};

export default function CICOValidationLabel(props: Props): JSX.Element | null {
  const warningMessage = getWarningMessage(props);
  if (warningMessage) {
    return (
      <span className="u-btn-af-height">
        <WarningIcon className="u-mini-spacing-right" />
        {warningMessage}
      </span>
    );
  }
  return null;
}
